import React, { useEffect, useMemo, useState } from "react";
import { Row, Col, Button } from "reactstrap";
import CustomForm from "../../custom/Forms/CustomForm.js";
import SelectInput from "../../custom/components/Select-Input/SelectInput.js";
import TextInput from "../../custom/components/Text-Input/TextInput.js";
import TextAreaInput from "../../custom/components/TextArea-Input/TextAreaInput.js";
import { Link, useNavigate, useParams } from "react-router-dom";
import CheckboxInput from "../../custom/components/CheckBox-Input/CheckboxInput.js";
import Asterisks from "../../custom/components/Asterisks/Asterisks.js";
import { validate } from "../../custom/validations/Validate.js";
import { getRecords, saveRecords } from "../../services/api.service.js";
import { toast } from "react-toastify";
import { LoaderCreatePage } from "../Loader/Loader.js";
import { loaderOverlay } from "../../Style/loaderOverly.js";
import DatePicker from "../../custom/components/Date-Picker/DatePicker.js";
import { createPageData, basicFormData } from "./MaterialApprovalFile.js";
import BasicPopupModel from "../../custom_components/Components/BasicPopupModel.js";
import Select from "react-select"
import CustomError from "../../custom/components/Errors/CustomError.js";

const MaterialApprovalFrom = ({ intakeNo, materialId, setSelectedMaterial, setShowMaterialApproval }) => {
  const { id } = useParams();
  const navigate = useNavigate()

  const {
    payload,
    headerName,
    validationType,
    createEndpoint,
  } = createPageData();

  const initialPayload = useMemo(() => payload, []);
  const [loadingData, setLoadingData] = useState(id ? true : false);
  const [loadingSubmit, setLoadingSubmit] = useState(id ? true : false);
  const [formData, setFormData] = useState(basicFormData());
  const [formErrors, setFormErrors] = useState({});
  // role
  const [techiniciansSelectOptions, setTechiniciansSelectOptions] = useState([])
  const [selectedTechinicians, setSelectedTechinicians] = useState({})
  const [techniciansError, setTechniciansError] = useState("")
  const [materialsData, setMaterialsData] = useState({})
  const [popup, setPopup] = useState(false)
  const [action, setAction] = useState("")
  const [scrapReasonsOptions, setScrapReasonsOptions] = useState([])
  const [selectedScrapReasons, setSelectedScrapReasons] = useState({})
  const [scrapReasonsError, setScrapReasonsError] = useState("")
  const scrapStatusOptions = [
    {value:1, label:"Scrapped"},
    {value:2, label:"Pending Approval"},
  ]
  const [selectedScrapStatus, setSelectedScrapStatus] = useState({ value: 2, label: "Pending Approval" })

  useEffect(() => {
    getTechniciansData()
    getMaterialsData()
    getScrapReasonsData()
  }, [intakeNo])





  const getScrapReasonsData = async () => {
    setLoadingData(true)
    try {
      let payload = {
        modelName: "scrap_reason_masters",
        whereCondition: {
          is_active: true
        },
        schema: initialPayload?.schema
      };

      const responseData = await getRecords(payload, "/getRecords");
      const newArray = responseData.data?.map(item => ({
        value: item.id,
        label: item.reason
      }));
      setScrapReasonsOptions(newArray)
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setLoadingData(false)
  };


  const getMaterialsData = async () => {
    setLoadingData(true)
    try {
      let payload = {
        modelName: "material_intakes",
        whereCondition: {
          is_active: true,
          intake_no: intakeNo
        },
        "include": [
          { "model": "material_masters", "as": "material" },
          { "model": "user_masters", "as": "inspected_by_user" },
        ],
        schema: initialPayload?.schema
      };

      const responseData = await getRecords(payload, "/getRecords");
      setMaterialsData(responseData?.data[0])
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setLoadingData(false)
  };

  const getTechniciansData = async () => {
    setLoadingData(true)
    try {
      let payload = {
        modelName: "user_masters",
        whereCondition: {
          is_active: true,
          role_id: 2
        },
        schema: initialPayload?.schema
      };

      const responseData = await getRecords(payload, "/getRecords");
      const newArray = responseData.data?.map(item => ({
        value: item.id,
        label: `${item.first_name} ${item.last_name}`
      }));
      setTechiniciansSelectOptions(newArray)
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setLoadingData(false)
  };

  const onInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (name === "is_repairable" && checked === false) {
      setTechniciansError("")
    }
    setFormErrors((prevErrors) => {
      const fieldError = validate(validationType, { [name]: value });
      return {
        ...prevErrors,
        [name]: fieldError[name] || null,
      };
    });

    setFormData((prevState) => ({
      ...prevState,
      inputData: {
        ...prevState.inputData,
        [name]:
          type === "checkbox"
            ? checked === true
              ? 1
              : 0
            : name === "alt_mobile_number" && value === ""
              ? null
              : value,
      },
    }));
  };

  const handleTechniciansSelect = (options) => {
    const selectedValue = options ? options.value : "";

    setSelectedTechinicians(options);

    setFormData((prevState) => ({
      ...prevState,
      inputData: {
        ...prevState.inputData,
        technician_id: selectedValue,
      },
    }));

    setTechniciansError("")
  };

  const handleScrapReasonsSelect = (options) => {
    const selectedValue = options ? options.value : "";

    setSelectedScrapReasons(options);

    setFormData((prevState) => ({
      ...prevState,
      inputData: {
        ...prevState.inputData,
        scrap_reason_id: selectedValue,
      },
    }));

    setScrapReasonsError("")
  };



  // Submit

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      setLoadingSubmit(true)
      
      const userDetails = JSON.parse(localStorage.getItem("authUser"));
      const userId = userDetails?.id    
      

      if (action==="Approve" && !selectedTechinicians?.value) {
        setTechniciansError("Technician is required")
        return
      }

      if (action==="Reject" && !selectedScrapReasons?.value) {
        setScrapReasonsError("Scrap Reason is required")
        return
      }

      const currentDate = new Date()
      let finalPayload
      let scrapPayload
      let approvePayload

      if (action === "Approve") {

        approvePayload = {
          "modelName": "material_intakes",
          "schema": initialPayload?.schema,
          "id": materialId,
          "inputData": {
            "intake_no": intakeNo,
            "is_repairable": true,
            "technician_id": selectedTechinicians?.value,
            "inspected_by": userId,
            "inspected_at": currentDate.toString(),
            "received_by": userId,
            "inspected_remark": formData.inputData.inspected_remark,
            "is_active": formData.inputData.is_active,
            "created_by": userId,
            "updated_by": userId
          }
        }

      } else {

        scrapPayload = {
          "modelName": "scraps",
          "schema": initialPayload?.schema,

          "inputData": {
            "intake_id": materialId,
            "scrap_reason_id": selectedScrapReasons?.value,
            "approved_by": userDetails?.id || "",
            "approved_at": currentDate.toString(),
            "remark": formData.inputData.scrap_remark,
            "status": "Pending Approval",
            "is_active": true
          }
        }
      }

      finalPayload = action === "Approve" ? approvePayload : scrapPayload
      // console.log(finalPayload)
      // return

      const responseData = await saveRecords(finalPayload, createEndpoint);

      // Handle response
      if (responseData && responseData.code === 1) {
        toast.success(
          `${headerName} ${id ? "updated" : "saved"} successfully!`
        );
        if (action === "Approve") {
          navigate("/job-card-list")
        } else {
          navigate("/scrap-list")
        }
        
      } else {
        toast.error(
          responseData.message || `Error while saving ${headerName}!`
        );
      }
    } catch (error) {
      console.error("Error during submission:", error);
      toast.error("An unexpected error occurred. Please try again.");
    } finally {
      setLoadingSubmit(false);
      // setPopup(false)
    }
  };



  return (
    <div>
      <form className="card p-3">

        {/* <Row className="mt-2">

          <Col lg="2">
            <CheckboxInput
              name="is_repairable"
              label="Is Repairable"
              value={formData?.inputData?.is_repairable}
              checked={formData?.inputData?.is_repairable}
              handleTextChange={onInputChange}
              parentClassName="form-check"
              checkBoxClassName="form-check-input"
              labelClassName="form-check-label"
            />
          </Col>

          <Col lg="2">
            <CheckboxInput
              name="is_active"
              label="Is Active"
              value={formData?.inputData?.is_active}
              checked={formData?.inputData?.is_active}
              handleTextChange={onInputChange}
              parentClassName="form-check"
              checkBoxClassName="form-check-input"
              labelClassName="form-check-label"
            />
          </Col>
        </Row> */}

        <Row className="mt-2">

          <Col md="6" className="mt-3">
            <TextInput
              label="Inspected By"
              name="inspected_by"
              value={
                materialsData?.inspected_by_user
                  ? `${materialsData.inspected_by_user.first_name || ""} ${materialsData.inspected_by_user.last_name || ""}`.trim() || "-"
                  : "-"
              }
              onChange={onInputChange}
              placeholder="Inspected By"
              inputClassName="form-control"
              labelClassName="form-label"
              disabled={true}
            />
          </Col>

          <Col md="6" className="mt-3">
            <TextInput
              label="Inspected Remark"
              name="inspected_remark"
              value={materialsData?.inspected_remark || "-"}
              onChange={onInputChange}
              placeholder="Inspected Remark"
              inputClassName="form-control"
              labelClassName="form-label"
              disabled={true}
            />
          </Col>
          <Col md="6" className="mt-3">
            <TextInput
              label="Status"
              name="material_name"
              value={materialsData?.status || "-"}
              onChange={onInputChange}
              inputClassName="form-control"
              labelClassName="form-label"
              disabled={true}
            />
          </Col>
          <Col md="6" className="mt-3">
            <TextInput
              label="Material Name"
              name="material_name"
              value={materialsData?.material?.name || "-"}
              onChange={onInputChange}
              inputClassName="form-control"
              labelClassName="form-label"
              disabled={true}
            />
          </Col>

         

        </Row>

        <div className="mt-3 d-flex gap-3 flex-wrap">
          <button type="button" className="btn btn-primary" onClick={() => {
            setPopup(true)
            setAction("Approve")
          }}>
            Approve
          </button>
          <button type="button" onClick={() => {
            setPopup(true)
            setAction("Reject")
          }} className="btn btn-secondary">
            Reject
          </button>
        </div>
      </form>

      <BasicPopupModel
        isVisible={popup}
        onClose={() => setPopup(false)}
        title={action === "Approve" ? "Approve Material Approval" : "Reject Material Approval"}
      >
        <div>
          {action === "Approve" ? (<form onSubmit={handleSubmit}>
            <div className="mt-3 mb-2">
              <div>
                <span className="text-muted">Intake No: </span> {intakeNo}
              </div>
            </div>
            <Row>
              <Col md="6" className="mt-1">
                <label htmlFor="technicians">
                  Technicians <span className="text-danger">*</span>
                </label>
                <Select
                  options={techiniciansSelectOptions}
                  value={selectedTechinicians}
                  onChange={handleTechniciansSelect}
                  placeholder="Select Technicians"
                  classNamePrefix="react-select"
                  className={techniciansError.length ? "input-error" : ""}
                  styles={{
                    control: (provided, state) => ({
                      ...provided,
                      borderColor: techniciansError.length
                        ? "#d15757"
                        : state.isFocused
                          ? "blue"
                          : "#ccc",
                    })
                  }}
                  
                />
                {techniciansError && <CustomError error={techniciansError} />}
              </Col>
              <Col md="6" className="mt-1">
                <TextInput
                  label="Remark"
                  name="inspected_remark"
                  value={formData.inputData.inspected_remark}
                  onChange={onInputChange}
                  inputClassName="form-control"
                  labelClassName="form-label"
                />
              </Col>
            </Row>
            <div className="mt-3 d-flex gap-3 flex-wrap">
              <button type="submit" className="btn btn-primary">
                Submit
              </button>
              <button type="button" onClick={() => {
                setPopup(false)
              }} className="btn btn-secondary">
                Cancel
              </button>
            </div>
          </form>) : (<form onSubmit={handleSubmit}>

            <div className="mt-3 mb-2">
              <div className="mb-4">
                  <span className="alert alert-warning p-2"> ! Warning: The Material will enter into the scrap </span>
              </div>
              <div>
                <span className="text-muted">Intake No: </span> {intakeNo}
              </div>
            </div>
            <Row>
              <Col md="6" className="mt-1">
                <label htmlFor="scrap_reasons">
                    Scrap Reasons <span className="text-danger">*</span>
                </label>
                <Select
                  options={scrapReasonsOptions}
                  value={selectedScrapReasons}
                  onChange={handleScrapReasonsSelect}
                  placeholder="Select Scrap Reasons"
                  classNamePrefix="react-select"
                  className={scrapReasonsError.length ? "input-error" : ""}
                    styles={{
                      control: (provided, state) => ({
                        ...provided,
                        borderColor: scrapReasonsError.length
                          ? "#d15757"
                          : state.isFocused
                            ? "blue"
                            : "#ccc",
                      })
                    }}
                />
                  {scrapReasonsError && <CustomError error={scrapReasonsError} />}
              </Col>
              <Col md="6" className="mt-1">
                <TextInput
                  label="Scrap Remark"
                  name="scrap_remark"
                  value={formData.inputData.scrap_remark}
                  onChange={onInputChange}
                  inputClassName="form-control"
                  labelClassName="form-label"
                />
              </Col>
            </Row>
            <div className="mt-3 d-flex gap-3 flex-wrap">
              <button type="submit" className="btn btn-primary">
                Submit
              </button>
              <button type="button" onClick={() => {
                setPopup(false)
              }} className="btn btn-secondary">
                Cancel
              </button>
            </div>
          </form>)}
          {loadingSubmit && (
            <div style={loaderOverlay}>
              <LoaderCreatePage />
            </div>
          )}
        </div>
      </BasicPopupModel>
      {loadingData && (
        <div style={loaderOverlay}>
          <LoaderCreatePage />
        </div>
      )}
    </div>
  );
};

export default MaterialApprovalFrom;
